module.exports = __webpack_public_path__ + "img/section2_2.0015f919.png";